import Vue from 'vue'
import Router from 'vue-router'
import { routes } from './routes'
import ViewUI from 'view-design'
import store from '../store'
import { session, cookie } from '../libs/location'
import address from '@/api/address'
Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  base: address
})
let car = ['dlcd.dolinkhub.com', 'localhost:8080']

router.beforeEach((to, from, next) => {
  ViewUI.LoadingBar.start()
  if (to.query.token || to.query.authorization) { // 认证信息可能通过url参数的token或authorization传递
    console.log(car.indexOf(window.location.host), 'car.indexOf(window.location.host)')
    const authorization = to.query.token || to.query.authorization
    // session.setObject(authorization)
    if (car.indexOf(window.location.host) !== -1) {
      cookie.setCookie(`token${window.document.location.href.split('/')[3]}`, authorization, {
        path: `/${window.document.location.href.split('/')[3]}/`, // 关键作用域设置
        secure: true, // HTTPS 必须
        domain: 'dolinkhub.com'
      })
      cookie.setCookie(`token_${pathSegment}`, authorization, {
        path: `/${pathSegment}/`, // 关键作用域设置
        secure: true, // HTTPS 必须
        domain: 'dolinkhub.com'
      })
    } else {
      cookie.setCookie(`token`, authorization, { path: '/' })
    }
  }
  let cookieName = ''
  if (car.indexOf(window.location.host) !== -1) {
    cookieName = `token${window.document.location.href.split('/')[3]}`
  } else {
    cookieName = 'token'
  }
  let token = cookie.getCookie(cookieName)
  console.log(cookie.getCookie(cookieName), cookieName, 'token')
  document.title = to.meta.title
  if (to.name === 'resetPassword' || to.name === 'error_scanerror' || to.name === 'autoLoginDD' || to.name === 'autoLoginLark' || to.name === 'autoLoginPC') {
    next()
  } else {
    store.dispatch('doGetSetting').then(data => {
      if (token) {
        // 设置语言和皮肤
        if (session.getItem('userInfo')) {
          store.dispatch('doChangeSkin', JSON.parse(session.getItem('userInfo')).skinColor)
        }
        if (to.path === '/' || to.path === '/login' || to.path === `/${window.location.pathname.split('/')[1]}/`) {
          next({ name: 'home' })
        } else {
          next()
        }
      } else {
        // alert(to.path)
        if (to.path === '/' || to.path === '/login' || to.path === '/link') {
          next()
        } else {
          next({ name: 'login' })
        }
      }
    })
  }
})

router.afterEach(to => {
  ViewUI.LoadingBar.finish()
  window.scrollTo(0, 0)
})

export default router
